import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Calendar, MapPin, Gift, Shirt, Globe, Users } from "lucide-react";

function MerchDayFlyer() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1167B1] via-[#0d5390] to-[#17181B] py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Main Flyer Card */}
        <Card className="overflow-hidden shadow-2xl border-4 border-[#FFE102]">
          {/* Header Section */}
          <div className="bg-[#FFE102] text-[#17181B] p-8 text-center relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full opacity-10">
              <div className="absolute top-4 left-4 w-32 h-32 bg-[#17181B] rounded-full"></div>
              <div className="absolute bottom-4 right-4 w-40 h-40 bg-[#17181B] rounded-full"></div>
            </div>
            <div className="relative z-10">
              <Badge className="bg-[#17181B] text-[#FFE102] text-sm font-bold mb-4 px-6 py-2">
                EXCLUSIVE EVENT
              </Badge>
              <h1 className="text-6xl md:text-7xl font-black mb-2 tracking-tight">
                MERCH<span className="text-[#1167B1]">DAY</span>
              </h1>
              <div className="text-3xl md:text-4xl font-bold mb-4">
                PARTY
              </div>
              <p className="text-xl font-semibold">
                Celebrating the Website Relaunch
              </p>
            </div>
          </div>

          {/* Logos Section */}
          <div className="bg-white py-6 flex justify-center items-center space-x-8 border-y-4 border-[#1167B1]">
            <img 
              src="/flyer-assets/logo.jpg" 
              alt="Calvin D. Butts Inc." 
              className="h-24 w-auto"
            />
            <div className="h-20 w-px bg-[#1167B1]"></div>
            <img 
              src="/flyer-assets/mental_health.png" 
              alt="Mental Health Initiative" 
              className="h-24 w-auto"
            />
          </div>

          {/* Main Content */}
          <div className="bg-gradient-to-br from-[#1167B1] to-[#0d5390] text-white p-8">
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              {/* Date & Time */}
              <div className="bg-white/10 backdrop-blur rounded-xl p-6 border-2 border-[#FFE102]">
                <Calendar className="w-12 h-12 text-[#FFE102] mb-3" />
                <h3 className="text-2xl font-bold mb-2">When</h3>
                <p className="text-xl">TBA</p>
                <p className="text-lg opacity-90">Stay tuned for date & time!</p>
              </div>

              {/* Location */}
              <div className="bg-white/10 backdrop-blur rounded-xl p-6 border-2 border-[#FFE102]">
                <MapPin className="w-12 h-12 text-[#FFE102] mb-3" />
                <h3 className="text-2xl font-bold mb-2">Where</h3>
                <p className="text-xl font-bold">42 Bar & Grill</p>
                <p className="text-lg opacity-90">Atlanta, GA</p>
              </div>
            </div>

            {/* Special Promotion */}
            <div className="bg-[#FFE102] text-[#17181B] rounded-2xl p-8 mb-6 border-4 border-white shadow-xl">
              <div className="flex items-center justify-center mb-4">
                <Shirt className="w-16 h-16 mr-4" />
                <Gift className="w-16 h-16" />
              </div>
              <h2 className="text-3xl md:text-4xl font-black text-center mb-4">
                WEAR YOUR CDB APPAREL
              </h2>
              <div className="bg-[#17181B] text-[#FFE102] rounded-xl p-6 text-center">
                <p className="text-2xl font-bold mb-2">
                  🎟️ ENTER TO WIN! 🎟️
                </p>
                <p className="text-xl">
                  Wear any Calvin D. Butts Inc. apparel and you'll be automatically entered into our exclusive raffle!
                </p>
              </div>
            </div>

            {/* Event Highlights */}
            <div className="grid md:grid-cols-3 gap-4 mb-6">
              <div className="text-center bg-white/10 backdrop-blur rounded-lg p-4">
                <Globe className="w-10 h-10 text-[#FFE102] mx-auto mb-2" />
                <p className="font-bold text-lg">Website Launch</p>
                <p className="text-sm opacity-90">New digital home!</p>
              </div>
              <div className="text-center bg-white/10 backdrop-blur rounded-lg p-4">
                <Users className="w-10 h-10 text-[#FFE102] mx-auto mb-2" />
                <p className="font-bold text-lg">Community Vibes</p>
                <p className="text-sm opacity-90">Connect & celebrate!</p>
              </div>
              <div className="text-center bg-white/10 backdrop-blur rounded-lg p-4">
                <Gift className="w-10 h-10 text-[#FFE102] mx-auto mb-2" />
                <p className="font-bold text-lg">Prize Raffle</p>
                <p className="text-sm opacity-90">Exclusive giveaways!</p>
              </div>
            </div>

            {/* Website URL */}
            <div className="bg-white rounded-2xl p-6 text-center">
              <p className="text-[#17181B] font-bold text-lg mb-2">Visit Our New Website</p>
              <a 
                href="https://calvin-butts-shop.preview.emergentagent.com/" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1167B1] font-bold text-xl md:text-2xl hover:underline break-all"
              >
                vibrant-faith.preview.emergentagent.com
              </a>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-[#17181B] text-white p-6 text-center">
            <h3 className="text-2xl font-bold mb-2 text-[#FFE102]">
              Hosted by Chris Butts
            </h3>
            <p className="text-lg mb-4">Calvin D. Butts Inc.</p>
            <p className="text-sm opacity-75">
              Empowering Youth • Building Futures • Serving Metro Atlanta
            </p>
            <div className="mt-4 pt-4 border-t border-white/20">
              <p className="text-xs opacity-60">
                Follow us for event updates and more information
              </p>
            </div>
          </div>
        </Card>

        {/* Additional Info Cards */}
        <div className="grid md:grid-cols-2 gap-6 mt-8">
          <Card className="bg-white/10 backdrop-blur border-2 border-[#FFE102] p-6 text-white">
            <h3 className="text-xl font-bold mb-3 text-[#FFE102]">🎉 What to Expect</h3>
            <ul className="space-y-2">
              <li>✓ Celebrate our new digital presence</li>
              <li>✓ Connect with the CDB community</li>
              <li>✓ Exclusive merchandise showcase</li>
              <li>✓ Raffle prizes for apparel wearers</li>
              <li>✓ Food, drinks, and great vibes!</li>
            </ul>
          </Card>

          <Card className="bg-white/10 backdrop-blur border-2 border-[#FFE102] p-6 text-white">
            <h3 className="text-xl font-bold mb-3 text-[#FFE102]">📧 Stay Updated</h3>
            <p className="mb-4">
              Don't have CDB apparel yet? Shop now and be ready for the party!
            </p>
            <a 
              href="https://www.calvinbuttsms.org/shop/apparel"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#FFE102] text-[#17181B] font-bold px-6 py-3 rounded-full hover:bg-[#FFE102]/90 transition-colors"
            >
              Shop CDB Apparel →
            </a>
          </Card>
        </div>

        {/* Print Button */}
        <div className="text-center mt-8">
          <button 
            onClick={() => window.print()}
            className="bg-[#FFE102] text-[#17181B] font-bold px-8 py-4 rounded-full hover:bg-[#FFE102]/90 transition-colors shadow-xl text-lg"
          >
            🖨️ Print This Flyer
          </button>
        </div>
      </div>
    </div>
  );
}

export default MerchDayFlyer;
